<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_table_of_contents_1">Avant-première</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_table_of_contents_1">Résumé</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_table_of_contents_1">Biographie</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_table_of_contents_1">Dédicace</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_table_of_contents_1">Chapitre un</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_table_of_contents_1">Chapitre deux</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0008#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre trois</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0009#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre quatre</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre cinq</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre six</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre sept</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0013#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre huit</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0014#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre neuf</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0015#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre dix</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0016#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre onze</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0017#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre douze</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0018#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre treize</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0019#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre quatorze</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0020#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Chapitre quinze</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0021" title="Link target outside of Sample">Visitez Dreamspinner Press</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0022#auto_bookmark_table_of_contents_1" title="Link target outside of Sample">Droits d’auteur</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?7f6263ae